import type { HelpFile } from '../../types/help'
import { RecentNotificationsTestIds } from '../../../testids/RecentNotificationsTestIds'

export const recentNotificationsHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [RecentNotificationsTestIds.recentNotificationsCard]: null,
    [RecentNotificationsTestIds.cardTitleRecentNotifications]: 'Aktuelle relevante Ereignisse — Zugriffsänderungen, Genehmigungsaktivitäten und Provisionierungsstatus.',
    [RecentNotificationsTestIds.dashboardViewAllNotifications]: 'Vollständiges Benachrichtigungsprotokoll mit allen empfangenen Meldungen.',
  },
}
